import { type ReactNode } from 'react';
import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material';
import { useLanguage } from '../../../../../context/LanguageContext';

const EMPTY_PLACEHOLDER = <Box component="span" sx={{ color: 'text.disabled' }}>—</Box>;

export function SentenceText({ children, disabled = false }: { children: ReactNode; disabled?: boolean }) {
    return (
        <Typography variant="caption" sx={{ color: disabled ? 'text.disabled' : 'text.primary', whiteSpace: 'nowrap' }}>
            {children}
        </Typography>
    );
}

interface SentenceSelectProps<T extends string> {
    value: T | '';
    options: { value: T; label: string }[];
    minWidth: number;
    onChange: (value: T | '') => void;
    disabled?: boolean;
}

export function SentenceSelect<T extends string>({ value, options, minWidth, onChange, disabled = false }: SentenceSelectProps<T>) {
    const { t } = useLanguage();
    return (
        <FormControl size="small" disabled={disabled} sx={{ minWidth, flexShrink: 0 }}>
            <Select
                displayEmpty
                value={value}
                onChange={(e) => onChange(e.target.value as T | '')}
                renderValue={(selected) => options.find(option => option.value === selected)?.label ?? EMPTY_PLACEHOLDER}
            >
                <MenuItem value=""><em>{t('pages.clients.queryBuilder.simple.emptyOption')}</em></MenuItem>
                {options.map(option => (
                    <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
